import { legacyColors, legacyShadows } from '~/legacyTheme';
import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    imgLayout: {
      display: 'grid',
      gridTemplateColumns: 'auto auto',
      gridTemplateRows: 'auto auto auto 1fr',
      gridTemplateAreas: `
        "cropper upload"
        "cropper preview"
        "cropper actions"
        "cropper void"
      `,
      justifyItems: 'center',
      gridGap: theme.spacing(1),
    },
    imgCropper: {
      gridArea: 'cropper',
      width: 640,
      '& .cropFrame': {
        width: 640,
        boxShadow: legacyShadows.inset1,
        '& .cropContainer': {
          overflow: 'hidden',
          height: 360,
          maxWidth: 'fit-content',
          margin: 'auto',
          '& .cropImage': {
            display: 'block',
            maxWidth: '100%',
            height: 'inherit',
          },
        },
      },
      '& .cropActions': {
        display: 'flex',
        justifyContent: 'center',
      },
    },
    imgUpload: {
      '& input[type="file"]': {
        display: 'none',
      },
    },
    imgActions: {
      gridArea: 'actions',
      display: 'flex',
      justifyContent: 'center',
    },
    imgPreview: {
      gridArea: 'preview',
      height: 160,
      width: 160,
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: legacyColors.grey4,
      overflow: 'hidden',
    },
    dialogFooter: {
      justifyContent: 'space-between',
      '& .statusMessage': {
        display: 'flex',
        justifyContent: 'flex-start',
      },
      '& .buttons': {
        display: 'flex',
        justifyContent: 'flex-end',
      },
    },
  };
};
